import { z } from 'zod';
import { Id, IsoDateTime, Sha256Hex, TenantId } from './common.ts';

export const Classification = z
  .enum(['public', 'internal', 'confidential', 'restricted'])
  .meta({ id: 'Classification' });
export type Classification = z.infer<typeof Classification>;

/** A stored, versioned, hashed file or generated document. */
export const Artifact = z
  .object({
    artifactId: Id,
    tenantId: TenantId,
    version: z.number().int().positive(),
    sha256: Sha256Hex,
    mediaType: z.string().min(1),
    sizeBytes: z.number().int().nonnegative(),
    name: z.string().min(1),
    /** Principal id of the owner. */
    owner: z.string().min(1),
    classification: Classification,
    region: z.string().min(1),
    provenance: z.looseObject({
      /** `upload`, `agent`, `tool`, `system` … */
      source: z.string().min(1),
      taskId: Id.optional(),
      actionId: Id.optional(),
      derivedFrom: z.array(z.string()).optional(),
      createdBy: z.string().optional(),
    }),
    aclSubjects: z.array(z.string()).default([]),
    retention: z.object({ policy: z.string().min(1), deleteAfter: IsoDateTime.optional() }),
    downloadPolicy: z.enum(['allowed', 'view_only', 'denied']),
    createdAt: IsoDateTime,
  })
  .meta({ id: 'Artifact' });
export type Artifact = z.infer<typeof Artifact>;
